import SlideComponent from '../components/slick';
import MenuComponent from '../components/menu';
import SearchComponent from '../components/search';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    /* jQuery('.slick-banner').slick({
      dots: false,
      infinite: false,
    }); */
    new SlideComponent({
      el: '.slick-banner',
    });

    new MenuComponent();
    new SearchComponent();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js